<template>
  <div class="login-pane">
    <div class="bg-wrap">

    </div>
  </div>
</template>

<script setup>

</script>



<style scoped lang="scss">
.login-pane {
  height: 100%;
  overflow-y: auto;
  cursor: pointer;
  .bg-wrap {
    height: 790px;
    background-image: url("https://static.rhkj.com/renhe_fe/other/301.png");
    background-size: cover;
    background-position: 45% 50%;
  }
}
</style>
